import React from "react";
const CaretUp = () => {
  return (
    <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg">
      <g stroke="null" transform="rotate(180 15 15)" id="svg_9">
        <g transform="matrix(.36127 0 0 .38225 11.806 200.377)" id="svg_8">
          <g id="svg_5" transform="rotate(180 8.842 -484.963)">
            <polygon
              points="19.904308319091797,-475.6557922363281 8.842111587524414,-487.8351135253906 -2.220083236694336,-475.6557922363281 -5.142171859741211,-478.87298583984375 8.842111587524414,-494.2695007324219 22.82639503479004,-478.87298583984375"
              id="svg_6"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default CaretUp;



// WEBPACK FOOTER //
// ./src/icons/CaretUp.js